import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Line } from "react-chartjs-2";

export default class Reports extends Component {
  state = {
    data: {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [
        {
          label: "My Daily Logins",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "rgba(75,192,192,0.4)",
          borderColor: "rgba(75,192,192,1)",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "rgba(75,192,192,1)",
          pointBackgroundColor: "#fff",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgba(75,192,192,1)",
          pointHoverBorderColor: "rgba(220,220,220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [65, 59, 80, 81, 106, 95, 140],
        },
      ],
    },
    trainerOptions: [
      {
        id: 1,
        name: "USER REPORTS",
        subname: "0 inactive",
        icons: <i class="fas fa-user"></i>,
      },
      // {
      //   id: 2,
      //   name: "COURSE REPORTS",
      //   subname: "1 instructor · 0 learners",
      //   icons: <i class="fas fa-book"></i>,
      // },
      // {
      //   id: 3,
      //   name: "BRANCH REPORT",
      //   subname: "0 files",
      //   icons: <i class="fas fa-code-branch"></i>,
      // },
      // {
      //   id: 4,
      //   name: "GROUP REPORT ",
      //   subname: "Sequential rule set",
      //   icons: <i class="fas fa-users"></i>,
      // },
      // {
      //   id: 5,
      //   name: "TEST REPORT ",
      //   subname: "Sequential rule set",
      //   icons: <i class="fas fa-users"></i>,
      // },
    ],
  };
  onSelectedOptions = (id) => {
    if (id === 1) {
      this.props.history.push("/admin/reports/user");
    } else if (id === 2) {
      this.props.history.push("/admin/reports/course");
    } else if (id === 3) {
    } else if (id === 4) {
    } else if (id === 5) {
      this.props.history.push("/admin/reports/test");
    }
  };
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> / <b>Reports</b>
                </h5>
              </div>
            </div>
          </div>

          <div>
            <div className="row m-0 p-2 create-course ">
              <div className="col-md-8 border-right">
                <div className="row">
                  <div className="col-md-6">
                    <div className="btn-group">
                      <div className="btn btn-light active">Today</div>
                      <div className="btn btn-light">Yesterday</div>
                      <div className="btn btn-light">Week</div>
                      <div className="btn btn-light">Month</div>
                    </div>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <div className="btn-group">
                      <div className="btn btn-light active">
                        <i className="fas fa-chart-line"></i>
                      </div>
                      <div className="btn btn-light">
                        <i class="fas fa-list-ul"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <Line data={this.state.data}></Line>
              </div>
              <div className="col-md-4 right-section pl-0">
                {this.state.trainerOptions.map((option) => (
                  <div
                    onClick={this.onSelectedOptions.bind(this, option.id)}
                    className={`card card-selector shadow-sm p-2 m-2 ${
                      option.id == this.state.selectedOption ? "selected" : ""
                    }`}
                  >
                    <div className="row">
                      <div className="col-2">
                        <div className="icon d-flex justify-content-center align-items-center shadow-sm border">
                          {option.icons}
                        </div>
                      </div>
                      <div className="col-10 d-flex align-items-center">
                        <h5 className="m-0 btn-link">{option.name}</h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
